import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { LowDataProvider } from "@/context/LowDataContext";
import SmoothScroll from "@/components/SmoothScroll";
import Header from "@/components/Header";
import TrustBar from "@/components/TrustBar";
import FcaTopBanner from "@/components/FcaTopBanner";
import { Seo } from "@/components/Seo";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import MavulaAssistant from "@/components/MavulaAssistant";
import LowDataToggle from "@/components/LowDataToggle";
import CookieConsent from "@/components/CookieConsent";

import HomePage from "@/pages/HomePage";
import HowItWorksPage from "@/pages/HowItWorksPage";
import CountriesPage from "@/pages/CountriesPage";
import InvestorsPage from "@/pages/InvestorsPage";
import PoliciesPage from "@/pages/PoliciesPage";
import RegisterInterestPage from "@/pages/RegisterInterestPage";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import PayPage from "@/pages/PayPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import PaymentCancelPage from "@/pages/PaymentCancelPage";
import FlwSuccessPage from "@/pages/FlwSuccessPage";
import ProjectsPage from "@/pages/ProjectsPage";
import ProjectDetailPage from "@/pages/ProjectDetailPage";
import TeamPage from "@/pages/TeamPage";
import FaqPage from "@/pages/FaqPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import SafetyPage from "@/pages/SafetyPage";
import BuildersPage from "@/pages/BuildersPage";
import StoriesPage from "@/pages/StoriesPage";
import RoadmapPage from "@/pages/RoadmapPage";
import ImpactPage from "@/pages/ImpactPage";
import PulaPage from "@/pages/PulaPage";
import ComparePage from "@/pages/ComparePage";
import ApplyBuilderPage from "@/pages/ApplyBuilderPage";
import ScamWarningPage from "@/pages/ScamWarningPage";
import WhyMavulaPage from "@/pages/WhyMavulaPage";
import AgentPortalPage from "@/pages/AgentPortalPage";
import AgentReferralRedirect from "@/pages/AgentReferralRedirect";
import HowYourMoneyIsHeldPage from "@/pages/HowYourMoneyIsHeldPage";
import RiskRealitiesPage from "@/pages/RiskRealitiesPage";
import ProtectionsPage from "@/pages/ProtectionsPage";
import OfficeHoursPage from "@/pages/OfficeHoursPage";
import SecurityPage from "@/pages/SecurityPage";
import ReservePage from "@/pages/ReservePage";
import SiteVisitPage from "@/pages/SiteVisitPage";
import DownloadsPage from "@/pages/DownloadsPage";
import AboutPage from "@/pages/AboutPage";
import LegalStatusPage from "@/pages/LegalStatusPage";
import WaitingListPage from "@/pages/WaitingListPage";
import SubscriptionSuccessPage from "@/pages/SubscriptionSuccessPage";
import SubscriptionCancelPage from "@/pages/SubscriptionCancelPage";
import FoundingMemberPage from "@/pages/FoundingMemberPage";
import LearnLandingPage from "@/pages/learn/LearnLandingPage";
import LearnBundlesPage from "@/pages/learn/LearnBundlesPage";
import LearnVerifyPage from "@/pages/learn/LearnVerifyPage";
import AdminLearnWaitlistPage from "@/pages/learn/AdminLearnWaitlistPage";
import CoursePlayerPage from "@/pages/learn/CoursePlayerPage";
import EmployerPage from "@/pages/learn/EmployerPage";
import AiTeamPage from "@/pages/AiTeamPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Seo />
        <LowDataProvider>
          <AuthProvider>
            <SmoothScroll>
              <FcaTopBanner />
              <Header />
              <TrustBar />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/how-it-works" element={<HowItWorksPage />} />
                <Route path="/countries" element={<CountriesPage />} />
                <Route path="/investors" element={<InvestorsPage />} />
                <Route path="/policies" element={<PoliciesPage />} />
                <Route path="/register-interest" element={<RegisterInterestPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/pay" element={<PayPage />} />
                <Route path="/pay/success" element={<PaymentSuccessPage />} />
                <Route path="/pay/cancel" element={<PaymentCancelPage />} />
                <Route path="/pay/flw/success" element={<FlwSuccessPage />} />
                <Route path="/projects" element={<ProjectsPage />} />
                <Route path="/projects/:id" element={<ProjectDetailPage />} />
                <Route path="/team" element={<TeamPage />} />
                <Route path="/faq" element={<FaqPage />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route path="/admin" element={<AdminDashboardPage />} />
                <Route path="/safety" element={<SafetyPage />} />
                <Route path="/builders" element={<BuildersPage />} />
                <Route path="/stories" element={<StoriesPage />} />
                <Route path="/roadmap" element={<RoadmapPage />} />
                <Route path="/impact" element={<ImpactPage />} />
                <Route path="/pula" element={<PulaPage />} />
                <Route path="/compare" element={<ComparePage />} />
                <Route path="/apply-builder" element={<ApplyBuilderPage />} />
                <Route path="/scam-warning" element={<ScamWarningPage />} />
                <Route path="/why-mavula" element={<WhyMavulaPage />} />
                <Route path="/agent-portal" element={<AgentPortalPage />} />
                <Route path="/downloads" element={<DownloadsPage />} />
                <Route path="/r/:code" element={<AgentReferralRedirect />} />
                <Route path="/how-your-money-is-held" element={<HowYourMoneyIsHeldPage />} />
                <Route path="/risk-realities" element={<RiskRealitiesPage />} />
                <Route path="/protections" element={<ProtectionsPage />} />
                <Route path="/office-hours" element={<OfficeHoursPage />} />
                <Route path="/security" element={<SecurityPage />} />
                <Route path="/reserve/:id" element={<ReservePage />} />
                <Route path="/site-visits" element={<SiteVisitPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/legal-status" element={<LegalStatusPage />} />
                <Route path="/waiting-list" element={<WaitingListPage />} />
                <Route path="/subscription/success" element={<SubscriptionSuccessPage />} />
                <Route path="/subscription/cancel" element={<SubscriptionCancelPage />} />
                <Route path="/founding-member" element={<FoundingMemberPage />} />
                <Route path="/learn" element={<LearnLandingPage />} />
                <Route path="/learn/bundles" element={<LearnBundlesPage />} />
                <Route path="/verify" element={<LearnVerifyPage />} />
                <Route path="/verify/:certId" element={<LearnVerifyPage />} />
                <Route path="/admin/learn-waitlist" element={<AdminLearnWaitlistPage />} />
                <Route path="/learn/course/:slug" element={<CoursePlayerPage />} />
                <Route path="/learn/employer" element={<EmployerPage />} />
                <Route path="/admin/ai-team" element={<AiTeamPage />} />
              </Routes>
              <Footer />
              <WhatsAppButton />
              <MavulaAssistant />
              <LowDataToggle />
              <CookieConsent />
              <Toaster position="top-right" richColors closeButton />
            </SmoothScroll>
          </AuthProvider>
        </LowDataProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
